
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { AuthImage, AuthView } from '@Components/Auth/Auth.styled';
import Layout from '@Components/Layout';
import { RIA } from '@Constants/ACL';
import { NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import React from 'react';
import { Col, Container, Row } from 'styled-bootstrap-grid';
const LoginForm = dynamic(() => import('@Components/Auth/LoginForm'));

type Props = {};

const LoginPage: NextPage = ({}: Props) => {
  const { t: tAuth } = useTranslation('Auth');

  return (
    <Layout
      seoData={{
        title: tAuth('login'),
      }}
      hideNavbar={true}
    >
      <AuthView>
        <AuthImage />
        <Container fluid>
          <Row justifyContent="end">
            <Col col={12} xxl={5} xl={6} lg={8}>
              <LoginForm />
            </Col>
          </Row>
        </Container>
      </AuthView>
    </Layout>
  );
};

 async function _getStaticProps() {
  return {
    props: {
      ACL: {
        action: RIA,
      },
    },
  };
}

export default LoginPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/auth/login',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  